import { IonButton, IonCard, IonCardContent, IonCol, IonContent, IonIcon, IonPage, IonRow, IonText, useIonToast } from '@ionic/react';
import {
  calendarOutline,
  downloadOutline,
  folderOutline,
  heartOutline,
  leafOutline,
  locationOutline,
  pricetagOutline,
  shareOutline,
} from 'ionicons/icons';
import React, { useEffect, useRef, useState } from 'react';
import { Modal } from 'react-responsive-modal';
import { RouteComponentProps, useHistory } from 'react-router';
import { Link } from 'react-router-dom';

import ProgressBar from '../../components/campaign/ProgressBar';
import LoadingContainer from '../../components/loading/LoadingContainer';
import Slideshow from '../../components/slideshow/Slideshow';
import TimerFlip from '../../components/timer/TimerFlip';
import HR from '../../layouts/HR';
import Toolbar2 from '../../layouts/Toolbar2';
import { baseUrl, isHome, isWebView, objIsEmpty, passToWebView } from '../../library/Funcs';
import { CampaignViewAction } from '../../redux/actions/Campaign';
import { useAppDispatch, useAppSelector } from '../../redux/hooks';

import './CampaignPage.css';
import 'react-responsive-modal/styles.css';
import { AuthContext } from '../../context/AuthContext';
import { useSpring } from 'react-spring';
import DownloadDoc from '../../components/campaign/DownloadDoc';

interface Props extends RouteComponentProps<{
  campaign_id: string
}> { }

const CampaignPage: React.FC<Props> = ({ match }, props) => {
  const [toolbarBg, setToolbarBg] = useState('transparent')
  const [titleColor, setTitleColor] = useState('transparent')
  const [mapShow, setMapShow] = useState(false);

  const carTotal = 7;

  const [carAnimDuration1, setCarAnimDuration1] = useState(2000)
  const [carAnimPause1, setCarAnimPause1] = useState(false)
  const [lastCarIndex1, setLastCarIndex1] = useState(1);
  const [lastCarMoving1, setLastCarMoving1] = useState(null as any);

  const [carAnimDuration2, setCarAnimDuration2] = useState(3000)
  const [carAnimPause2, setCarAnimPause2] = useState(false)
  const [lastCarIndex2, setLastCarIndex2] = useState(3);
  const [lastCarMoving2, setLastCarMoving2] = useState(null as any);

  const [toast, dismiss] = useIonToast();

  const history = useHistory();
  const dispatch = useAppDispatch()

  const { loading, campaignView } = useAppSelector(state => state.campaignView)

  useEffect(() => {
    dispatch(CampaignViewAction(match.params.campaign_id))

    return () => {
      if (isHome()) {
        dispatch({ type: 'CAMPAIGN_VIEW_RESET' })
      }
    }
  }, [dispatch])

  const randomNumber = (min: number, max: number) => {
    return Math.round(Math.random() * (max - min)) + min;
  }

  useSpring({
    config: { duration: carAnimDuration1 },
    from: { left: -40 },
    to: { left: window.innerWidth },
    cancel: campaignView.project?.id != 122,
    delay: 0,
    loop: true,
    pause: carAnimPause1,
    onStart: () => {
      let carIndex = 1;
      do {
        carIndex = randomNumber(1, carTotal);
        setLastCarIndex1(carIndex);
      } while (carIndex == lastCarIndex1)

      const cars = document.querySelectorAll<HTMLElement>(".road-car-front div");
      for (let i = 0; i < cars.length; i++) {
        const carItem = cars[i];
        carItem.style.display = "none"
      }

      const car = document.querySelector<HTMLElement>(".road-car-front-" + carIndex)!;
      car.style.display = "";
      setLastCarMoving1(car)
    },
    onChange: (pos) => {
      if (lastCarMoving1 != null) {
        lastCarMoving1.style.left = pos.value.left + "px"

        if (pos.value.left == window.innerWidth) {
          setCarAnimPause1(true);

          const duration = randomNumber(1500, 4000);
          setCarAnimDuration1(duration)

          const timeout = randomNumber(1000, 3000);
          setTimeout(() => {
            setCarAnimPause1(false);
          }, timeout);

          for (let i = 1; i <= carTotal; i++) {
            const car = document.querySelector<HTMLElement>(".road-car-front-" + i)!;
            car.style.left = "-40px";
          }
        }
      }
    }
  })

  useSpring({
    config: { duration: carAnimDuration2 },
    from: { right: -40 },
    to: { right: window.innerWidth },
    cancel: campaignView.project?.id != 122,
    delay: 0,
    loop: true,
    pause: carAnimPause2,
    onStart: () => {
      let carIndex = 1;
      do {
        carIndex = randomNumber(1, carTotal);
        setLastCarIndex2(carIndex);
      } while (carIndex == lastCarIndex2)

      const cars = document.querySelectorAll<HTMLElement>(".road-car-back div");
      for (let i = 0; i < cars.length; i++) {
        const carItem = cars[i];
        carItem.style.display = "none"
      }

      const car = document.querySelector<HTMLElement>(".road-car-back-" + carIndex)!;
      car.style.display = "";
      setLastCarMoving2(car)
    },
    onChange: (pos) => {
      if (lastCarMoving2 != null) {
        lastCarMoving2.style.right = pos.value.right + "px"

        if (pos.value.right == window.innerWidth) {
          setCarAnimPause2(true);

          const duration = randomNumber(2000, 5000);
          setCarAnimDuration2(duration)

          const timeout = randomNumber(1000, 3000);
          setTimeout(() => {
            setCarAnimPause2(false);
          }, timeout);

          for (let i = 1; i <= carTotal; i++) {
            const car = document.querySelector<HTMLElement>(".road-car-back-" + i)!;
            car.style.right = "-40px";
          }
        }
      }
    }
  })

  useEffect(() => {
    if (!objIsEmpty(campaignView) && !loading) {
      const state = history.location.state as any;

      if (state?.showUpdates) {
        history.push(`${match.params.campaign_id}/updates`, campaignView?.updates)
      }
    }
  }, [loading])

  const shareCampaignHandler = () => {
    passToWebView('shareText', 'معرفی به دوستان', campaignView.project?.share_text);
  }

  const showMapHandler = () => {
    setMapShow(true);
  }

  const hideMapHandler = () => {
    setMapShow(false);
  }

  const changeHeightHandler = (e: any) => {
    const scrollY = e.detail.currentY;

    const alpha = scrollY / 180;

    setToolbarBg('rgba(8, 185, 138, ' + alpha + ')')

    if (scrollY > 210) {
      setTitleColor('rgba(255, 255, 255, 1)')
    } else {
      setTitleColor('transparent')
    }
  }

  const toolbarButtons = <React.Fragment>
    {isWebView() ?
      <IonButton shape="round" color="white" onClick={shareCampaignHandler}>
        <IonIcon icon={shareOutline} />
      </IonButton> : null}

    <IonButton shape="round" color="white" onClick={showMapHandler}>
      <IonIcon icon={locationOutline} />
    </IonButton>
  </React.Fragment>

  return <LoadingContainer loading={loading}>
    <IonPage className="campaign">
      <Toolbar2 title={campaignView.project?.title} endButtons={toolbarButtons} hasBackButton hasShadow background={toolbarBg} titleColor={titleColor} />

      <IonContent className={campaignView?.project?.finalized ? "main-content finalized" : "main-content"} scrollEvents onIonScroll={changeHeightHandler}>
        <IonCard className="slideshow-card">
          <IonCardContent>
            {campaignView.images !== undefined ? <Slideshow images={campaignView.images} /> : null}
          </IonCardContent>
        </IonCard>

        <IonCard>
          <IonCardContent>
            {!campaignView?.project?.isPlanting ?
              <IonRow>
                <IonCol>
                  <IonText className="title">{campaignView.project?.title}</IonText>
                </IonCol>
              </IonRow>
              :
              <IonRow>
                <IonCol>
                  <IonText className="title">{campaignView.project?.title}</IonText>
                </IonCol>
                <IonCol className="download-document">
                  <DownloadDoc id={campaignView.project?.id} title={campaignView.project?.title} />
                </IonCol>
              </IonRow>
            }
            <IonRow>
              <IonCol size="6">
                <IonText className="category"><IonIcon src={folderOutline} />{campaignView.project?.category_name}</IonText>
              </IonCol>
              <IonCol size="6" className="ion-text-left">
                <IonText className="category"><IonIcon src={calendarOutline} />{campaignView.project?.date}</IonText>
              </IonCol>
            </IonRow>
            <HR />
            <IonRow>
              <IonCol>
                <div className="ion-text-justify">{campaignView.project?.short_desc}</div>
              </IonCol>
            </IonRow>
          </IonCardContent>
        </IonCard>

        {campaignView.project?.id != 122 && !(campaignView.project?.finalized || campaignView.project?.remain < 0) ?
          <IonCard className="timer-card">
            <IonCardContent>
              {campaignView.project?.remainDate !== undefined ?
                <div className="timer-container">
                  <TimerFlip endDate={campaignView.project?.remainDate} />
                </div> : null}
            </IonCardContent>
          </IonCard>
          : null}

        {campaignView.project?.isPlanting ?
          <IonCard>
            <IonCardContent>
              <IonRow>
                <IonCol size="6">
                  <IonText className="price-title"><IonIcon src={leafOutline} />نهال های محقق شده</IonText>
                </IonCol>
                <IonCol size="6">
                  <IonText className="price-value">{campaignView.project?.seedlings.paid}</IonText>
                </IonCol>
              </IonRow>
              <IonRow>
                <IonCol size="6">
                  <IonText className="price-title"><IonIcon src={leafOutline} />تعداد نهال هدف</IonText>
                </IonCol>
                <IonCol size="6">
                  <IonText className="price-value">{campaignView.project?.seedlings.goal}</IonText>
                </IonCol>
              </IonRow>
            </IonCardContent>
          </IonCard> : null}

        {!campaignView.project?.isPlanting && campaignView.project?.id != 122 ?
          <IonCard>
            <IonCardContent>
              <IonRow>
                <IonCol size="4">
                  <IonText className="price-title"><IonIcon src={pricetagOutline} />محقق شده</IonText>
                </IonCol>
                <IonCol size="8">
                  <IonText className="price-value">{campaignView.project?.donates}</IonText>
                </IonCol>
              </IonRow>
              <IonRow>
                <IonCol size="4">
                  <IonText className="price-title"><IonIcon src={pricetagOutline} />مبلغ هدف</IonText>
                </IonCol>
                <IonCol size="8">
                  <IonText className="price-value">{campaignView.project?.goal}</IonText>
                </IonCol>
              </IonRow>
            </IonCardContent>

            <ProgressBar width={campaignView.project?.percentage + "%"} />
          </IonCard> : null}

        {campaignView.project?.id == 122 ?
          <IonCard>
            <IonCardContent>
              <IonRow>
                <IonCol size="5">
                  <IonText className="price-title"><IonIcon src={pricetagOutline} />متراژ محقق شده</IonText>
                </IonCol>
                <IonCol size="7">
                  <IonText className="price-value">{Math.floor(parseFloat((campaignView.project?.donates).replace(/\D*/g, "")) / 10000000)} متر</IonText>
                </IonCol>
              </IonRow>
              <IonRow>
                <IonCol size="5">
                  <IonText className="price-title"><IonIcon src={pricetagOutline} />متراژ هدف</IonText>
                </IonCol>
                <IonCol size="7">
                  <IonText className="price-value">{Math.floor(parseFloat((campaignView.project?.goal).replace(/\D*/g, "")) / 10000000000)} کیلومتر</IonText>
                </IonCol>
              </IonRow>
              <IonRow>
                <IonCol size="5">
                  <IonText className="price-title"><IonIcon src={pricetagOutline} />مبلغ محقق شده</IonText>
                </IonCol>
                <IonCol size="7">
                  <IonText className="price-value">{campaignView.project?.donates}</IonText>
                </IonCol>
              </IonRow>
            </IonCardContent>
          </IonCard> : null}

        {campaignView.project?.id == 122 ?
          <IonCard>
            <div className='road'>
              <div>
                <div className='road-car-front'>
                  <div className='road-car-front-1'></div>
                  <div className='road-car-front-2'></div>
                  <div className='road-car-front-3'></div>
                  <div className='road-car-front-4'></div>
                  <div className='road-car-front-5'></div>
                  <div className='road-car-front-6'></div>
                  <div className='road-car-front-7'></div>
                </div>

                <div className='road-car-back'>
                  <div className='road-car-back-1'></div>
                  <div className='road-car-back-2'></div>
                  <div className='road-car-back-3'></div>
                  <div className='road-car-back-4'></div>
                  <div className='road-car-back-5'></div>
                  <div className='road-car-back-6'></div>
                  <div className='road-car-back-7'></div>
                </div>

                <div className="fences">
                  <div className='fence' style={{ width: campaignView.project?.percentage + "%" }}></div>
                  <div className='fence_remain'></div>
                </div>
              </div>
            </div>
          </IonCard> : null}

        <IonRow className="selector-container">
          <IonCol size="3">
            <Link to={{ pathname: `${match.params.campaign_id}/detail/desc`, state: campaignView.project?.description }}>
              <IonButton className="selector-button"> توضیحات </IonButton>
            </Link>
          </IonCol>
          <IonCol size="3">
            <Link to={{ pathname: `${match.params.campaign_id}/detail/comments`, state: campaignView?.comments }}>
              <IonButton className="selector-button"> نظرات </IonButton>
            </Link>
          </IonCol>
          <IonCol size="3">
            <Link to={{ pathname: `${match.params.campaign_id}/detail/donations`, state: { donations: campaignView?.donations, donationsTotal: campaignView?.donationsTotal } }}>
              <IonButton className="selector-button"> حامیان </IonButton>
            </Link>
          </IonCol>
          <IonCol size="3">
            <Link to={{ pathname: `${match.params.campaign_id}/detail/updates`, state: campaignView?.updates }}>
              <IonButton className="selector-button"> گزارش‌ها </IonButton>
            </Link>
          </IonCol>
        </IonRow>
      </IonContent>

      {!campaignView?.project?.finalized ?
        <IonCard className="donate-button">
          <IonCardContent>
            <Link to={{ pathname: `/campaign/${campaignView.project?.id}/donation` + (match.params.campaign_id.indexOf('-') > 0 ? '/' + match.params.campaign_id.split('-')[1] : '') }}>
              <IonButton expand="block">
                {campaignView.project?.isPlanting ? <IonText>اهدای نهال</IonText> : <IonText>حمایت می کنم</IonText>}
                <IonIcon slot="start" icon={campaignView.project?.isPlanting ? leafOutline : heartOutline } />
              </IonButton>
            </Link>
          </IonCardContent>
        </IonCard> : null}

      <Modal open={mapShow} onClose={hideMapHandler} center showCloseIcon={false} classNames={{ modalContainer: "single-map-modal" }}>
        <iframe src={baseUrl + `/single-map/${campaignView.project?.id}`} />
      </Modal>
    </IonPage>
  </LoadingContainer>
}

export default CampaignPage;